<template>
  <div class="login">
    <div class="login_bg flex f-jc-c">
      <div class="login_context">
        <p class="fs-16 fw-5">手机号授权</p>
        <div class="formBox">
            <van-field
              v-model="mobile"
              placeholder="请输入手机号码"
              maxlength="11"
              type="tel"
              label="手机号"
            >
            </van-field>
            <van-field v-model="code" center clearable label="验证码" placeholder="请输入验证码">
              <template #button>
                <!-- <van-button size="small" color="#F0F0F0" type="primary"></van-button> -->
                <button class="code_btn" :class="isGetCode ? 'c-51A' : ''" v-show="show" @click="getCode" :disabled="!isGetCode">获取验证码</button>
                <span v-show="!show" class="count">{{ count }} s</span>
              </template>
            </van-field>
          <div class="flex f-ai-c f-d-c">
            <van-button
              class="submit_btn"
              :class="hasSubmit ? 'opacity-1' : ''"
              type="primary"
              size="large"
              color="#58BE6B"
              :loading="loading"
              @click="$_handleSubmit"
              :disabled='!hasSubmit'
              >确定授权</van-button
            >
            <van-button
              class="close_btn"
              type="primary"
              size="large"
              color="#F0F0F0"
              @click="toPage"
              >关闭</van-button
            >
          </div>
        </div>
          
      </div>
    </div>
    
    
  </div>
</template>
<script>
import {Toast} from 'vant'
import {toEntry} from '@/core/utils/utils';

export default {
  name: "login",
  data() {
    return {
      mobile: "",
      code: "",
      show: true,
      count: "",
      timer: null,
      finger:'',
      bizId:''
    };
  },
  computed: {
    loading() {
      return this.$store.state.login.loading;
    },
    isGetCode(){
      return this.mobile.length===11;
    },
    hasSubmit(){
      return !(this.mobile === '' || this.code === "");
    }
  },
  methods: {
    $_handleSubmit() {
      this.$store.dispatch({
        type: "login/loginIn",
        payload: {
          userPhoneNumber: this.mobile,
          validCode: this.code,
          bizId:this.bizId
        },
      }).then(({code,msg})=>{
        if(code==='0'){
          this.$store.dispatch({
            type: "exchangeEecord/history",
            payload: {
              userMobile: this.mobile,
              checkCode: this.code,
              projectIntegralId:localStorage.getItem('projectIntegralId'),
              key:this.bizId
            },
          }).then(({code, result})=>{
            if(code ==='0'){
              const oUserInfo={
                key:this.bizId,
                seqNo:result.seqNo ?? 'null',
                userMobile:this.mobile,
                projectIntegralId:localStorage.getItem('projectIntegralId')
              }
              localStorage.setItem('oUserInfo',JSON.stringify(oUserInfo));

              this.$router.push({
                path: "/user/exchangeEecord"
              });
            }
          })
        }else{
          this.$toast.fail(msg)
        }
      });
    },
    async getCode() {
      const { mobile } = this;
     
      if (!/^1[3456789]\d{9}$/.test(mobile)) {
        Toast({
          className:'jg_toast',
          message: '请输入正确的手机号',
          icon: 'https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/icon_jg.png',
        });
        return;
      }

      this.$store
        .dispatch({
          type: "login/sendCode",
          payload: { userPhoneNumber: mobile },
        })
        .then((data) => {
          const { code, msg ,result } = data;
          if (code === '0') {
            const { bizId } = result;
            this.bizId = bizId;
            localStorage.setItem('bizId', bizId);
            this.$toast.success("短信发送成功");
            this.countDown();
          }else{
            this.$toast.fail(msg);
          }
        })
        .catch((e) => {
          this.$toast.fail("短信发送失败");
        });
    },
    // 倒计时
    countDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    toPage(){
      toEntry(this.$router);
    }
  },
};
</script>
<style lang="scss">
.login {
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #DFF7EE 0%, #BFEFDB 100%);
  .c-51A{
    color: #51A865 !important;
  }
  .opacity-1{
    opacity: 1 !important;
  }
  &_bg{
    background: url('https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/bg.png') no-repeat center center;
    background-size: cover;
  }
  &_context{
    margin-top: 123px;
    width: 266px;
    height: 343px;
    background: #FBFBFB;
    border-radius: 7px;
    >p{
      margin: 42px 0 20px 0;
      padding: 0;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #323232;
      text-align: center;
    }
    .formBox {
      .code_btn{
        padding: 3px 8px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #868686;
        background: #F0F0F0;
        border-radius: 3px;
        border:0px;
      }
      .count{
        display: block;
        text-align: center;
        width: 85px;
        height: 26px;
        background: #F0F0F0;
        border-radius: 3px;
        font-weight: 600;
        color: #868686;
        font-size: 14px;
      }
      .submit_btn{
        margin: 33px 0 12px 0;
        border-radius: 3px;
        opacity: 0.49;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        width: 154px;
        height: 40px;
      }
      .close_btn{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51A865 !important;
        width: 154px;
        height: 40px;
        border-radius: 3px;
      }
    }
  }

  .van-field{
    padding: 15px 17px 0 17px;
    background-color: #FBFBFB;
    position: initial;
  }
  .van-field__label{
    margin-right: 10px;
    padding-bottom: 9px;
    width: 45px;
    color: #323232;
  }
  .van-cell__value{
    padding-bottom: 9px;
    border-bottom: 1px solid #DDDDDD;
    color: #868686;
    font-size: 14px;
  }
}
.jg_toast{
  min-width: 88px;
  .van-icon__image{
    width: 28px;
    height: 28px;
  }
}
</style>

